// Stacking order of the desktop's pseudo-app windows. A window is any element with class `content`;
// this file is the only place that sets their z-index, so new apps need nothing here.
//
// Layers, bottom to top:
//   1100+     windows, re-ranked on every focus so they never climb into the next layer
//   9000      signing-in overlay
//   9900      menu bar
//   99999     wallet picker
//   99999998  alerts
//   99999999  boot screen
const BASE_Z_INDEX = 1100

export function bringToFront (target) {
  if (!target) { return }

  const others = Array.from(document.querySelectorAll('.content'))
    .filter(el => el !== target)
    .sort((a, b) => (Number(a.style.zIndex) || 0) - (Number(b.style.zIndex) || 0))

  others.concat(target).forEach((el, rank) => {
    el.style.zIndex = BASE_Z_INDEX + rank
  })
}
